import { Injectable } from '@angular/core';
import { BaseResolver } from '../../../shared/base-classes/base.resolver';
import {
  HeroEventRecurrenceEnum,
  HeroEventResponseDto,
  IDisplayData
} from '@whetstoneeducation/hero-common';
import { AppResolverErrorHandlerService } from '../../../shared/services/resolver-error-handler.service';
import { AppEventService } from '../events.service';
import { ActivatedRouteSnapshot } from '@angular/router';
import { plainToClass } from 'class-transformer';

export interface IHeroCreateUpdateResolverData {
  heroEvent: HeroEventResponseDto;
  eventCategories: IDisplayData[];
}

@Injectable({ providedIn: 'root' })
export class AppHeroEventCreateEditResolver extends BaseResolver<{
  heroEvent: HeroEventResponseDto;
  eventCategories: IDisplayData[];
}> {
  constructor(
    public resolverErrorHandler: AppResolverErrorHandlerService,
    public eventService: AppEventService
  ) {
    super(resolverErrorHandler);
  }

  async handleResolve(route: ActivatedRouteSnapshot): Promise<{
    heroEvent: HeroEventResponseDto;
    eventCategories: IDisplayData[];
  }> {
    const id = route.params.id;
    if (!id || id === 'new') {
      const heroEvent = plainToClass(HeroEventResponseDto, {
        name: '',
        eventRefId: '',
        eventCategoryId: null,
        allowMultipleEntries: false,
        requireScanOut: false,
        openToAll: false,
        active: true,
        startDate: null,
        endDate: null,
        duration: 0,
        recurrence: HeroEventRecurrenceEnum.ONE_TIME,
        recurrenceScheduledDays: [],
        skipWeekends: true
      });
      return {
        heroEvent,
        eventCategories: await this.eventService.getEventCategoryOptions()
      };
    } else {
      return this.eventService.getEventUpdateResolverData(+id);
    }
  }
}
